import script from "./HeaderTableBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderTableBlock.vue?vue&type=script&setup=true&lang=js"

import "./HeaderTableBlock.vue?vue&type=style&index=0&id=376f6cdf&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-376f6cdf"]])

export default __exports__